import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';


@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(public snackBar: MatSnackBar) {
    // this.snackBar.dismiss();
  }

  // ngAfterViewInit(): void {
  //   document.onclick = (args: any) : void => {
  //     this.snackBar.dismiss();
  //   }
  // }

  config: MatSnackBarConfig = {
    duration: 1000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  }

  warnConfig: MatSnackBarConfig = {
    duration: 1000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  }

  alertConfig: MatSnackBarConfig = {
    duration: 1000,
    horizontalPosition: 'center',
    verticalPosition: 'top'
  }

  success(msg) {
    console.log("message")
    this.config['panelClass'] = ['notification', 'success'];
    this.snackBar.open(msg, '',this.config);
  }

  warn(msg) {
    this.warnConfig['panelClass'] = ['notification', 'warn'];
    this.snackBar.open(msg, '', this.warnConfig);

  }

  alert(msg){
    this.alertConfig['panelClass'] = ['notification', 'alert'];
    this.snackBar.open(msg, '', this.alertConfig);
  }

}
